import { render } from "./Subscribers.vue?vue&type=template&id=79582b96"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__